import React from "react";

import "./SearchControl.scss";

import { ReactComponent as SearchIcon } from "components/icons/search.svg";

export const SearchControl = (props: {
  placeholder: string;
  value?: string;
  onChange: (value: string) => void;
}): JSX.Element => {
  const onChange = (e: React.FormEvent<HTMLInputElement>) => {
    props.onChange(e.currentTarget.value);
  };

  return (
    <div className="searchControl">
      <input
        type="search"
        placeholder={props.placeholder}
        value={props.value}
        onChange={onChange}
      />
      <SearchIcon />
    </div>
  );
};
